// Layout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import ProfileNavbar from "../ProfileNavbar/ProfileNavbar";
import Header from "../Header/Header";

const Layout = () => {
  return (
    <div className="dashboard">
        <ProfileNavbar />
      <div className="dashRightView">
        <Header />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
